import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
const PRIVACY_CONTENT = <>
    <p data-id="element-98">
      Tu privacidad es importante para nosotros. Esta Política de Privacidad
      describe cómo recopilamos, usamos y protegemos la información personal que
      nos proporcionás al usar este sitio.
    </p>
    <h3 className="font-serif text-xl text-earth font-bold mt-6 mb-2" data-id="element-99">
      1. Información que recopilamos
    </h3>
    <p data-id="element-100">
      Recopilamos información que nos brindás voluntariamente al realizar una
      compra: nombre, correo electrónico y datos de pago (procesados de forma
      segura por nuestra pasarela de pagos, sin almacenar datos de tarjeta en
      nuestros servidores).
    </p>
    <h3 className="font-serif text-xl text-earth font-bold mt-6 mb-2" data-id="element-101">
      2. Uso de la información
    </h3>
    <p data-id="element-102">
      Usamos tus datos para enviarte el producto digital adquirido, brindar
      soporte y, si lo aceptás, comunicarte novedades. No vendemos ni
      compartimos tu información con terceros con fines comerciales.
    </p>
    <h3 className="font-serif text-xl text-earth font-bold mt-6 mb-2" data-id="element-103">
      3. Cookies y pixel de seguimiento
    </h3>
    <p data-id="element-104">
      Este sitio utiliza cookies y herramientas de análisis (como Meta Pixel)
      para medir el rendimiento de nuestras campañas y mejorar tu experiencia.
      Podés desactivar las cookies desde tu navegador.
    </p>
    <h3 className="font-serif text-xl text-earth font-bold mt-6 mb-2" data-id="element-105">
      4. Tus derechos
    </h3>
    <p data-id="element-106">
      Podés solicitar el acceso, rectificación o eliminación de tus datos
      personales en cualquier momento escribiéndonos desde el correo con el que
      hiciste tu compra.
    </p>
    <h3 className="font-serif text-xl text-earth font-bold mt-6 mb-2" data-id="element-107">
      5. Cambios en esta política
    </h3>
    <p data-id="element-108">
      Podemos actualizar esta política periódicamente. La versión vigente será
      siempre la publicada en este sitio.
    </p>
  </>;
const TERMS_CONTENT = <>
    <p data-id="element-109">
      Al acceder y utilizar este sitio web y al adquirir el producto digital
      "Embarazo Sin Acidez", aceptás los siguientes términos y condiciones.
    </p>
    <h3 className="font-serif text-xl text-earth font-bold mt-6 mb-2" data-id="element-110">
      1. Naturaleza del producto
    </h3>
    <p data-id="element-111">
      "Embarazo Sin Acidez" es un producto digital educativo en formato PDF
      descargable, junto con sus 5 bonus complementarios. No es un servicio
      médico, no diagnostica enfermedades ni reemplaza la consulta con
      profesionales de la salud.
    </p>
    <h3 className="font-serif text-xl text-earth font-bold mt-6 mb-2" data-id="element-112">
      2. Acceso y entrega
    </h3>
    <p data-id="element-113">
      Una vez completado el pago, recibirás el acceso al producto al correo
      electrónico que ingresaste. La entrega es inmediata y digital.
    </p>
    <h3 className="font-serif text-xl text-earth font-bold mt-6 mb-2" data-id="element-114">
      3. Garantía de devolución
    </h3>
    <p data-id="element-115">
      Ofrecemos una garantía de satisfacción de 7 días desde la fecha de compra.
      Si no estás conforme, te devolvemos el 100% de tu dinero, sin preguntas
      incómodas.
    </p>
    <h3 className="font-serif text-xl text-earth font-bold mt-6 mb-2" data-id="element-116">
      4. Propiedad intelectual
    </h3>
    <p data-id="element-117">
      Todo el contenido, marcas, textos, gráficos e imágenes son propiedad del
      autor y están protegidos por las leyes de derechos de autor. No está
      permitida su reproducción, distribución o reventa sin autorización
      escrita.
    </p>
    <h3 className="font-serif text-xl text-earth font-bold mt-6 mb-2" data-id="element-118">
      5. Uso aceptable
    </h3>
    <p data-id="element-119">
      El producto es de uso personal e intransferible. Compartir el archivo o
      las credenciales de acceso constituye una violación de estos términos.
    </p>
    <h3 className="font-serif text-xl text-earth font-bold mt-6 mb-2" data-id="element-120">
      6. Limitación de responsabilidad
    </h3>
    <p data-id="element-121">
      El contenido tiene fines educativos. El autor no se responsabiliza por
      decisiones de salud tomadas en base a la información del producto sin
      consulta médica previa.
    </p>
  </>;
export const Footer: React.FC = () => {
  const [modal, setModal] = useState<ModalType>(null);
  useEffect(() => {
    if (modal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [modal]);
  return <>
      <footer className="bg-earth text-cream py-10 px-4" data-id="element-122">
        <div className="max-w-4xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4 text-center md:text-left" data-id="element-123">
          <span className="font-sans text-xs text-cream/50" data-id="element-124">
            &copy; {new Date().getFullYear()} Embarazo Sin Acidez. Todos los
            derechos reservados.
          </span>

          <div className="flex items-center gap-6 font-sans text-sm" data-id="element-125">
            <button onClick={() => setModal('privacy')} className="text-cream/70 hover:text-cream transition-colors" data-id="element-126">
              Política de Privacidad
            </button>
            <span className="text-cream/20" data-id="element-127">|</span>
            <button onClick={() => setModal('terms')} className="text-cream/70 hover:text-cream transition-colors" data-id="element-128">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      {modal && <Modal title={modal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'} onClose={() => setModal(null)} data-id="element-129">
          {modal === 'privacy' ? PRIVACY_CONTENT : TERMS_CONTENT}
        </Modal>}
    </>;
};
interface ModalProps {
  title: string;
  onClose: () => void;
  children: React.ReactNode;
}
const Modal: React.FC<ModalProps> = ({
  title,
  onClose,
  children
}) => {
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleEsc);
    return () => window.removeEventListener('keydown', handleEsc);
  }, [onClose]);
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-earth/60 backdrop-blur-sm animate-in fade-in" onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-130">
      <div className="bg-cream w-full max-w-2xl max-h-[90vh] rounded-2xl shadow-2xl flex flex-col overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-131">
        <div className="flex items-center justify-between p-6 border-b border-terracotta/10 shrink-0" data-id="element-132">
          <h2 id="modal-title" className="font-serif text-2xl text-earth font-bold" data-id="element-133">
            {title}
          </h2>
          <button onClick={onClose} aria-label="Cerrar" className="w-9 h-9 rounded-full hover:bg-cream-card flex items-center justify-center text-earth-light hover:text-earth transition-colors" data-id="element-134">
            <X size={20} data-id="element-135" />
          </button>
        </div>

        <div className="overflow-y-auto p-6 md:p-8 font-sans text-earth-light leading-relaxed space-y-3 text-sm md:text-base" data-id="element-136">
          {children}
        </div>
      </div>
    </div>;
};